import * as React from 'react';

import { css, StyleSheet } from 'aphrodite';
import { Container } from 'reactstrap';
import text from '../locale';
import Page from './Page';
import View from './View';
import theme from '../theme';
import { mpTrackingScreens } from '../config/screens';
import newtheme from '../newtheme';
import LandingPageNewSitemap from './landingpagenew/LandingPageNewSitemap';

interface IProps {
    showSitemap: boolean;
}

class Terms extends React.Component<IProps, {}> {
    public render() {
        return (
            <Page className={css(styles.page)} title={text.terms.TITLE} trackingScreen={mpTrackingScreens.terms}>
                <Container>
                    <View>
                        <h1 className={css(styles.title)}>{text.terms.TITLE}</h1>

                        <p>
                            {' '}
                            This document describes the terms and conditions that govern your use of the Noa Service, offered by Noa News Limited (&quot;Noa&quot;, &quot;our&quot; or &quot;we&quot;), a Dublin, Ireland based
                            company.
                            {' '}
                        </p>
                        <ol>
                            <li> Definitions </li>
                            <li> Introduction </li>
                            <li> Changes to the Agreements </li>
                            <li> Enjoying Noa </li>
                            <li> Rights we grant you </li>
                            <li> Third Party Applications </li>
                            <li> User-Generated Content </li>
                            <li> Rights you grant us </li>
                            <li> User guidelines </li>
                            <li> Infringement and reporting User Content </li>
                            <li> Service limitations and modifications </li>
                            <li> Customer support </li>
                            <li> Payments, cancellations, and cooling off </li>
                            <li> Term and termination </li>
                            <li> Warranty and disclaimer </li>
                            <li> Limitation </li>
                            <li> Third party rights </li>
                            <li> Entire agreement </li>
                            <li> Severability and waiver </li>
                            <li> Assignment </li>
                            <li> Indemnification </li>
                            <li> Force Majeure </li>
                            <li> Governing Law and Jurisdiction </li>
                        </ol>
                        <h3 className={css(styles.sectionTitle)}> 1. Definitions </h3>
                        <p>
                            {' '}
                            Before you continue we would like you to familiarise yourself with the following definitions in order to help you understand each of the terms detailed on this document.
                            For all items not listed in this section, we will define their definition in the body of the text in a clear and concise manner.
                            {' '}
                        </p>
                        <table>
                            <tbody>
                                <tr>
                                    <th className={css(styles.tableHeader)}>
                                        <p> &quot;Content&quot; : </p>
                                    </th>
                                    <td>
                                        <p> Refers to any material(s) distributed as part of the Noa Service, including those which are text, graphic, numeric, video, or audio based. </p>
                                    </td>
                                </tr>
                                <tr>
                                    <th className={css(styles.tableHeader)}>
                                        <p>&quot;Customer&quot; or &quot;user&quot; or &quot;you&quot; : </p>
                                    </th>
                                    <td>
                                        <p> Refers to any anyone registering or subscribing to, or making use of, the Noa Service. </p>
                                    </td>
                                </tr>
                                <tr>
                                    <th className={css(styles.tableHeader)}>
                                        <p>&quot;Enterprise Subscriber&quot;:</p>
                                    </th>
                                    <td>
                                        <p>
                                            {' '}
                                            Refers to a user who is granted access to the Noa Service as a result of payment made on their behalf by an organisation, as part of a group subscription.
                                            {' '}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <th className={css(styles.tableHeader)}>
                                        <p>&quot;Noa&quot; or &quot;we&quot; or &quot;our&quot; :</p>
                                    </th>
                                    <td>
                                        <p>
                                            {' '}
                                            Refers to Noa News Limited, a company registered in Ireland under company registration number 564767 and all subsidiaries and affiliates acting on behalf of
                                            Noa News Limited. A list of subsidiaries and affiliates are available upon request by using the contact form on our website.
                                            {' '}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <th className={css(styles.tableHeader)}>
                                        <p>&quot;Noa Service&quot; or &quot;Service&quot; : </p>
                                    </th>
                                    <td>
                                        <p>
                                            {' '}
                                            Refers to the provisioning of Content to Customers across Noa’s smartphone and tablet applications, audio players, websites, and any other digital or
                                            non-digital offerings that may be available from time to time (collectively, the &quot;Noa Site&quot;).
                                            {' '}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <th className={css(styles.tableHeader)}>
                                        <p>&quot;Publisher&quot; : </p>
                                    </th>
                                    <td>
                                        <p> Refers to a publisher whose Content is distributed by Noa. </p>
                                    </td>
                                </tr>
                                <tr>
                                    <th className={css(styles.tableHeader)}>
                                        <p>&quot;Subscriber&quot;: </p>
                                    </th>
                                    <td>
                                        <p>
                                            {' '}
                                            Refers to a user who is granted access to the Noa Service as a result of direct payment from that user, or payment made on their behalf by another
                                            individual, by way of a gift.
                                            {' '}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <th className={css(styles.tableHeader)}>
                                        <p>&quot;Subscription&quot; : </p>
                                    </th>
                                    <td>
                                        <p> Refers to any subscription tier offered by Noa that provides access to the Noa Service, including group subscriptions. </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <h3 className={css(styles.sectionTitle)}> 2. Introduction </h3>
                        <p>
                            {' '}
                            By using the Noa Service or by accessing any Content or other material that is made available by Noa through the Service you are entering into a binding contract with Noa.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            Your agreement with Noa includes these Terms and Conditions of Use (&quot;Terms&quot;) and our Privacy Policy. (The Terms, Privacy Policy, and any additional terms that you may agree
                            to are referred to together as the &quot;Agreements&quot;.) If you wish to review the terms of the Agreements, the effective version of the Agreements can be found on Noa’s website.
                            You acknowledge that you have read and understand the Agreements, accept these Agreements, and agree to be bound by them. If you don’t agree with (or cannot comply with)
                            the Agreements, then you may not use the Noa Service or consume any Content.
                            {' '}
                        </p>
                        <p>
                            <strong>Please read the Agreements carefully.</strong>
                            {' '}
                            They cover important information about Noa Services provided to you.
                            {' '}
                            <strong>
                                {' '}
                                The Agreements include information about future changes to the Agreements, limitations of liability, privacy information, a class action waiver, and resolution of
                                disputes by arbitration instead of in court.
                                {' '}
                            </strong>
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 3. Changes to the Agreements </h3>
                        <p>
                            {' '}
                            Occasionally we may, in our discretion, make changes to the Agreements. When we make material changes to the Agreements, we’ll provide you with prominent notice as
                            appropriate under the circumstances, e.g., by displaying a prominent notice within the Service or by sending you an email. In some cases, we will notify you in advance, and
                            your continued use of the Service after the changes have been made will constitute your acceptance of the changes. Please make sure that you read any such notice carefully.
                            If you do not wish to continue using the Service under the new version of the Agreements, you may terminate your relationship with Noa by ceasing to use the Noa Service.
                            These terms and conditions of use were last updated on the 25
                            <sup>th</sup>
                            {' '}
                            October 2018 and replace, with immediate effect, the previously published terms and conditions of
                            use.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 4. Enjoying Noa </h3>
                        <p> Here’s some information about all the ways that you can enjoy Noa. </p>
                        <h4 className={css(styles.sectionSubTitle)}> 4.1 Our Services </h4>
                        <p>
                            {' '}
                            Noa provides a streaming service that offers news, information and educational Content across the Noa Site. Certain Noa Services are provided to you on a metered-access
                            basis (i.e., a selection of content may be offered to you free of charge before a daily threshold is reached, requiring you to subscribe to the Noa Service in order to
                            continue listening).
                            {' '}
                            <a>If you </a>
                            <a> elect to pay, or an organisation or another party elects to pay on your behalf, for the Noa Service on a once off or periodic basi </a>
                            {' '}
                            s, you will be considered a
                            &quot;Subscriber&quot;.
                            {' '}
                        </p>
                        <p> Subscribers access to the Noa Service is subject to the Subscription you, or an organisation or any other party on your behalf, purchased. </p>
                        <p> Subscription may be terminated without notice if your periodic payment is not received on time. </p>
                        <h4 className={css(styles.sectionSubTitle)}> 4.2 Discount codes and other pre-paid offers </h4>
                        <p>
                            {' '}
                            If you have purchased or received a discount code, gift card, pre-paid offer or other offer provided or sold by or on behalf of Noa for access to the Noa Service (the
                            &quot;Code&quot;), separate terms and conditions presented to you along with the Code may also apply to your access to the Service and you agree to comply with any such terms and
                            conditions.
                            {' '}
                        </p>
                        <h4 className={css(styles.sectionSubTitle)}> 4.3 Trials </h4>
                        <p>
                            {' '}
                            From time to time Noa may offer unrestricted access to the Noa Service for a trial period, the duration of which may not be predefined and shall be determined by Noa at its
                            sole discretion, on either an aggregated or individual user basis (the &quot;Trial&quot;). Noa reserves the right, in its absolute discretion, to determine your eligibility for a
                            Trial, and, subject to applicable laws, to withdraw or to modify a Trial at any time without prior notice and with no liability, to the greatest extent permitted under the
                            law.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 5. Rights we grant you </h3>
                        <p>
                            {' '}
                            The Noa software applications and the Content are the property of either Noa or the associated Publisher (collectively, the &quot;Licensors&quot;). We grant you a limited,
                            non-exclusive, revocable licence to make use of the Noa Service, and a limited, non-exclusive, revocable licence to make personal, entertainment or educational use of the
                            Content (the &quot;Licence&quot;). This Licence shall remain in effect until and unless terminated by you or Noa. You promise and agree that you are using the Content for your own
                            personal, entertainment or educational use and that you will not redistribute the Noa Service or the Content for commercial gain without the prior written consent of Noa.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            The Noa software applications and the Content are licensed, not sold, to you, and the Licensors retain ownership of all copies of the Noa software applications and Content
                            even after installation on your personal computers, mobile devices, tablets, and/or other relevant devices (&quot;Devices&quot;).
                            {' '}
                        </p>
                        <p>
                            {' '}
                            All trademarks, service marks, trade names, logos, and domain names (the &quot;Brand Marks&quot;) are the sole property of Noa or its Licensors. The Agreements do not grant you any
                            rights to use any Brand Marks whether for commercial or non-commercial use.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            You agree to not to use the Noa Service, the Content, or any part thereof in any manner not expressly permitted by the Agreements. Except for the rights expressly granted
                            to you in these Agreements, Noa grants no right, title, or interest to you in the Noa Service or Content.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            Third party software (for example, open source software libraries) included in the Noa Service are licensed to you either under the Agreements or under the relevant third
                            party software library’s licence terms.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 6. Third Party Applications </h3>
                        <p>
                            {' '}
                            The Noa Service is integrated with third party applications, websites, and services (&quot;Third Party Applications&quot;) to make available digital content, products, and/or
                            services to you. These Third Party Applications may have their own terms and conditions of use and privacy policies and your use of these Third Party Applications will be
                            governed by and subject to such terms and conditions and privacy policies. You understand and agree that Noa does not endorse and is not responsible or liable for the
                            behaviour, features, or content of any Third Party Application or for any transaction you may enter into with the provider of any such Third Party Applications.
                        </p>
                        <p>
                            {' '}
                            Noa contains advertising and sponsorship. Advertisers and sponsors are responsible for ensuring that material submitted for inclusion through Noa complies with
                            international and national law. We are not responsible for any error or inaccuracy in advertising or sponsorship material.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 7. User-Generated Content </h3>
                        <p>
                            {' '}
                            Noa users may post, upload, and/or contribute (&quot;Post&quot;) content to the Service (which may include, for example, comments, URL or other links, messages, information, playlist
                            compilations, and/or other types of content) (&quot;User Content&quot;).
                            {' '}
                        </p>
                        <p> You promises that, with respect to any User Content you post on Noa: </p>
                        <p> (a) you have the right to post such User Content, </p>
                        <p>
                            {' '}
                            (b) its publishing and use by Noa as contemplated by the Agreement, does not violate the Agreement, applicable law, or the intellectual property (including without
                            limitation copyright), publicity, personality, or other rights of others or imply any affiliation with or endorsement of you or your User Content by Noa or any voice
                            broadcaster, journalist, publisher, entity or individual without express written consent from such individual or entity.
                            {' '}
                        </p>
                        <p> (c) it is not used to promote, or transmit any unlawful, harassing, libellous, abusive, threatening, harmful, hateful, or otherwise objectionable material, or </p>
                        <p> (d) it is not used to encourage conduct that could constitute a criminal offense or give rise to civil liability. </p>
                        <p>
                            {' '}
                            Noa may, but has no obligation to, monitor, review, or edit User Content. In all cases, Noa reserves the right to remove or disable access to any User Content for any or no
                            reason, including but not limited to, User Content that, in Noa’s sole discretion, violates the Agreements. Noa may take these actions without prior notification to you or
                            any third party. Removal or disabling of access to User Content shall be at our sole discretion, and we do not promise to remove or disable access to any specific User
                            Content.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            You are solely responsible for all User Content that you post. Noa is not responsible for User Content nor does it endorse any opinion contained in any User Content. YOU
                            AGREE THAT IF ANYONE BRINGS A CLAIM AGAINST NOA RELATED TO USER CONTENT THAT YOU POST, THEN, TO THE EXTENT PERMISSIBLE UNDER LOCAL LAW, YOU WILL INDEMNIFY AND HOLD NOA
                            HARMLESS FROM AND AGAINST ALL DAMAGES, LOSSES, AND EXPENSES OF ANY KIND (INCLUDING ALL LEGAL FEES AND COSTS) ARISING OUT OF SUCH CLAIM.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 8. Rights you grant us </h3>
                        <p>
                            {' '}
                            In consideration for the rights granted to you under the Agreements, you grant us the right (1) to allow the Noa Service to use the processor, bandwidth, and storage
                            hardware on your Device in order to facilitate the operation of the Service and (2) to provide service related, marketing, advertisement and other information to you.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            You grant Noa a non-exclusive, transferable, sub-licensable, royalty-free, perpetual (or, in jurisdictions where this is not permitted, for a term equal to the duration of
                            the Agreements plus twenty (20) years), irrevocable, fully paid, worldwide licence to use, reproduce, make available to the public, publish, translate, modify, create
                            derivative works from, and distribute any of your User Content in connection with the Service through any medium, whether alone or in combination with other content or
                            materials, in any manner and by any means, method or technology, whether now known or hereafter created. Aside from the rights specifically granted herein, you retain
                            ownership of all rights, including intellectual property rights, in the User Content. Where applicable and permitted under applicable law, you also agree to waive any
                            &quot;moral rights&quot; (or the equivalent under applicable law) such as your right to be identified as the author of any User Content, including Feedback, and your right to object
                            to derogatory treatment of such User Content.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            Title to all Content, design, software, processes and databases of Noa’s Service and all ideas, comments or suggestions relating to the Content or the Service (&quot;Feedback&quot;)
                            (collectively, &quot;Intellectual Property&quot;) remains the property of Noa (and its licensors). You must not contest or dispute that ownership or the validity of those
                            Intellectual Property rights.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            To the extent not owned by Noa, you grant the Company a royalty-free, transferable, irrevocable and perpetual licence to use for Noa’s own business purposes, any know-how,
                            techniques, ideas, methodologies, and similar Intellectual Property used by Noa in the provision of the Content and the Service to you.
                            {' '}
                        </p>
                        <p> With regard to Feedback that the you provide to Noa: </p>
                        <p>
                            {' '}
                            (a) all Intellectual Property in that Feedback, and anything created as a result of that Feedback (including new material, enhancements, modifications or derivative works),
                            are owned solely by Noa; and
                            {' '}
                        </p>
                        <p> (b) Noa may use or disclose the feedback for any purpose. </p>
                        <h3 className={css(styles.sectionTitle)}> 9. User guidelines </h3>
                        <p>
                            {' '}
                            In order to ensure that the Service is used in an enjoyable and educational way (i.e. the way it was designed to be used), we have established a few ground rules for you to
                            follow when using the Service. Please follow these rules and encourage other users to do the same when possible.
                            {' '}
                        </p>
                        <p> The following is not permitted for any reason whatsoever: </p>
                        <ul style={{ listStyleType: 'disc' }}>
                            <li> providing your password to any other person or using any other person’s username and password to access the Noa Service; </li>
                            <li>
                                {' '}
                                copying, redistributing, reproducing, recording, transferring, broadcasting, or making available to the public any part of the Noa Service or the Content, or otherwise
                                making any use of the Noa Service or the Content which is not expressly permitted under the Agreements or applicable law or which otherwise infringes the intellectual
                                property rights (such as copyright) in the Noa Service or the Content or any part of it;
                                {' '}
                            </li>
                            <li> using the Noa Service to import or copy any local files you do not have the legal right to import or copy in this way; </li>
                            <li> transferring copies of cached Content from an authorized Device to any other Device via any means; </li>
                            <li>
                                {' '}
                                reverse-engineering, decompiling, disassembling, modifying, or creating derivative works based on the Noa Service, Content or any part thereof unless permitted by
                                applicable law;
                                {' '}
                            </li>
                            <li> circumventing any technology used by Noa, its licensors, or any third party to protect the Content or the Service; </li>
                            <li> undermining the security or integrity of the underlying systems; </li>
                            <li>
                                {' '}
                                using the Content and or Service in a manner, nor transmitting, inputting or storing any data, that breaches any third party right or is objectionable, incorrect or
                                misleading;
                                {' '}
                            </li>
                            <li> selling, renting, sublicensing or leasing of any part of the Noa Service or the Content; </li>
                            <li> circumventing any territorial restrictions applied by Noa or its Licensors; </li>
                            <li> artificially increasing play count or the free listen balance or otherwise manipulating the Services by using a script or other automated process or software; </li>
                            <li>
                                {' '}
                                removing or altering any copyright, trademark, or other intellectual property notices contained on or provided through the Noa Service (including for the purpose of
                                disguising or changing any indications of the ownership or source of any Content);
                                {' '}
                            </li>
                            <li> &quot;crawling&quot; the Noa Service or otherwise using any automated means (including bots, scrapers, and spiders) to collect information from Noa; or </li>
                            <li>
                                {' '}
                                selling a user account or playlist, or otherwise accepting any compensation, financial or otherwise, to influence the name of an account or playlist or the content
                                included on an account or playlist.
                                {' '}
                            </li>
                        </ul>
                        <p>
                            {' '}
                            Please respect Noa, the owners of the Content, and other users of the Noa Service. Don’t engage in any activity, post any User Content, or register and/or use a username,
                            which is or includes material that:
                            {' '}
                        </p>
                        <ul style={{ listStyleType: 'disc' }}>
                            <li> is offensive, abusive, defamatory, pornographic, threatening, or obscene; </li>
                            <li>
                                {' '}
                                is illegal, or intended to promote or commit an illegal act of any kind, including but not limited to violations of intellectual property rights, privacy rights, or
                                proprietary rights of Noa or a third party;
                                {' '}
                            </li>
                            <li>
                                {' '}
                                includes your password or purposely includes any other user’s password or purposely includes personal data of third parties or is intended to solicit such personal
                                data;
                                {' '}
                            </li>
                            <li> includes malicious content such as malware, Trojan horses, or viruses, or otherwise interferes with any user’s access to the Service; </li>
                            <li> is intended to or does harass or bully other users; </li>
                            <li> impersonates or misrepresents your affiliation with another user, person, or entity, or is otherwise fraudulent, false, deceptive, or misleading; </li>
                            <li> uses automated means to artificially promote content; </li>
                            <li> involves the transmission of unsolicited mass mailings or other forms of spam, junk mail, chain letters, or similar, including through the Noa inbox; </li>
                            <li> involves commercial or sales activities, such as advertising, promotions, contests, sweepstakes, or pyramid schemes, that are not expressly authorized by Noa; </li>
                            <li> links to, references, or otherwise promotes commercial products or services, except as expressly authorized by Noa; </li>
                            <li>
                                {' '}
                                interferes with or in any way disrupts the Noa Service, tampers with, breaches, or attempts to probe, scan, or test for vulnerabilities in the Service or Noa’s computer
                                systems, network, usage rules, or any of Noa’s security components, authentication measures or any other protection measures applicable to the Service, the Content or
                                any part thereof; or
                                {' '}
                            </li>
                            <li> conflicts with the Agreements, as determined by Noa. </li>
                        </ul>
                        <p>
                            {' '}
                            On registration for an account to access the Noa Service, you must provide the Company with accurate, complete information, including your full name and your email address.
                            {' '}
                        </p>
                        <p> The email address you provide on registration must correspond to a named email account and not a generic or shared email account. </p>
                        <p>
                            {' '}
                            It is your responsibility to update and maintain changes to your account information on the Noa website. We are entitled to rely on any information provided by you as being
                            accurate.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            You acknowledge and agree that posting any such User Content may result in immediate termination or suspension of your continued access to the Noa Service. You also agree
                            that Noa may also reclaim your username for any reason.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            Please be thoughtful about how you use the Noa Service and what you share. The Noa Service may, in its current or future state, include social and interactive features,
                            including the ability to post User Content, share content, and make certain information about you public. Remember that shared or publicly available information may be used
                            and re-shared by other users on Noa or across the internet. Noa has no responsibility for your choices to post material on the Service. The consequences, if any, of any
                            User Content that you post on the Service are borne solely by you.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            Your password protects your user account, and you are solely responsible for keeping your password confidential and secure. You understand that you are responsible for all
                            use of your username, email, and password on the Service. IF YOUR USERNAME, EMAIL, OR PASSWORD IS LOST OR STOLEN, OR IF YOU BELIEVE THERE HAS BEEN UNAUTHORIZED ACCESS TO
                            YOUR ACCOUNT BY THIRD PARTIES, PLEASE NOTIFY US IMMEDIATELY AND CHANGE YOUR PASSWORD AS SOON AS POSSIBLE IN THE MY ACCOUNT SECTION OF THE Noa WEBSITE.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 10. Infringement and reporting User Content </h3>
                        <p>
                            {' '}
                            If you believe that any Content infringes your intellectual property rights or other rights please notify Noa by using the contact form on our website. If Noa is notified
                            by a copyright holder that any Content infringes a copyright, Noa may in its absolute discretion take actions without prior notification to the provider of that Content. If
                            the provider believes that the content is not infringing, the provider may submit a counter-notification to Noa with a request to restore the removed content.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 11. Service limitations and modifications </h3>
                        <p>
                            {' '}
                            Noa will make reasonable efforts to keep the Noa Service operational. However, certain technical difficulties or maintenance may, from time to time, result in temporary
                            interruptions. To the extent permissible under applicable law, Noa reserves the right, periodically and at any time, to modify or discontinue, temporarily or permanently,
                            functions and features of the Noa Service, with or without notice, all without liability to you, except where prohibited by law, for any interruption, modification, or
                            discontinuation of the Noa Service or any function or feature thereof. Notwithstanding the foregoing, if you have prepaid fees for Subscriptions that Noa permanently
                            discontinues prior to the end of the Pre-Paid Period (defined in the Payments, cancellations, and cooling off section), Noa will refund you the prepaid fees for the
                            Pre-Paid Period after such discontinuation. You understand, agree, and accept that Noa has no obligation to maintain, support, upgrade, or update the Service, or to provide
                            all or any specific content through the Service. This section will be enforced to the extent permissible by applicable law. Noa and/or the owners of any Content may, from
                            time to time, remove any such Content without notice to the extent permitted by applicable law.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            Use of Noa requires a device that is compatible with the Noa Service. Noa does not guarantee that the applications will be compatible with any device. You acknowledge that
                            Noa may from time to time issue upgraded versions of the applications and may automatically electronically upgrade the version of the applications. You consent to such
                            automatic upgrading.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            Noa’s Content (including any information we publish regarding third party products) is only for the your general information and is not intended to address particular
                            requirements.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            The Noa Content, including User-Generated Content and any other content provided by third parties and distributed by Noa, does not constitute any form of advice,
                            recommendation, representation, endorsement or arrangement by Noa. It is not intended to be and should not be relied upon by users in making (or refraining from making) any
                            decisions. Where applicable, appropriate independent advice should be obtained before making any such decision.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 12. Customer support </h3>
                        <p>
                            {' '}
                            For customer support with account-related and payment-related questions (&quot;Customer Support Queries&quot;), please submit your query to our customer service department at
                            {' '}
                            <a href="mailto:subscriptions@noanews.ie">subscriptions@noanews.ie</a>
                            {' '}
                            . We will use reasonable endeavours to respond to all Customer Support Queries within a reasonable
                            timeframe but we make no guarantees or warranties of any kind that any Customer Support Queries will be responded to within any particular time frame and/or that we will be
                            able to satisfactorily answer any such queries.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 13. Payments, cancellations, and cooling off </h3>
                        <p> THIS SECTION DOES NOT APPLY TO ENTERPRISE SUBSCRIBERS OR ORGANISATIONS PURCHASING GROUP SUBSCRIPTIONS. </p>
                        <p>
                            {' '}
                            Subscriptions can be purchased on the Noa website, or directly from a member of the Noa sales team, by paying a once off or periodic subscription fee, giving you access to
                            the Noa Service for a pre-specified period (&quot;Subscription Period&quot;). All Subscriptions will be charged on the day of purchase for the initial Subscription Period and on a
                            recurring basis thereafter at the end of each subsequent Subscription Period unless the Subscription is cancelled on the Noa website.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            When you purchase a Subscription or register for a Trial on the Noa Site, you consent to get access to the Noa Service immediately. Noa does not guarantee that the Service
                            will be available to you in any specific time period once you have registered for a Subscription or Trial. If you reside outside the United States and purchase a
                            Subscription to the Noa Service, you may change your mind for any or no reason and receive a full refund of all monies paid within fourteen (14) days (the &quot;Cooling-off
                            Period&quot;). Refunds will not, however, be provided if you have accessed the Noa Service at any time during the Cooling-off Period. Please submit your request for a refund to
                            {' '}
                            <a href="mailto:subscriptions@noanews.ie">subscriptions@noanews.ie</a>
                            {' '}
                            .
                            {' '}
                        </p>
                        <p>
                            {' '}
                            If you cancel your payment to Noa via the Noa website or terminate any of the Agreements (1) after you have accessed Noa during the Cooling-off Period, or (2) after the
                            Cooling-off Period is over (where applicable), or (3) before the end of the current subscription period, we will not refund any subscription fees already paid to Noa.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            Noa may change the price of your Subscription from time to time and will communicate such price changes to you in advance by email and, if applicable, how to accept such
                            changes. Price changes for Subscriptions will take effect at the start of the next Subscription Period following the date of the price change. As permitted by local law,
                            you accept the new price by continuing to use the Noa Service after the price change takes effect. If you do not agree with the price changes, you have the right to reject
                            the change by cancelling your subscription via the Noa website prior to the price change going into effect. Please therefore make sure you read any such notification of
                            price changes carefully.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 14. Term and termination </h3>
                        <p> THIS SECTION DOES NOT APPLY TO ENTERPRISE SUBSCRIBERS OR ORGANISATIONS PURCHASING GROUP SUBSCRIPTIONS. </p>
                        <p>
                            {' '}
                            The Agreements will continue to apply to you until terminated by either you or Noa. However, you acknowledge and agree that the perpetual licence granted by you in relation
                            to User Content, including Feedback, is irrevocable and will therefore continue after expiry or termination of any of the Agreements for any reason. Noa may terminate the
                            Agreements or suspend your access to the Noa Service at any time, including in the event of your actual or suspected unauthorised use of the Noa Service and/or Content, or
                            non-compliance with the Agreements. If you or Noa terminate the Agreements, or if Noa suspends your access to the Noa Service, you agree that Noa shall have no liability or
                            responsibility to you and Noa will not refund any amounts that you have already paid, to the fullest extent permitted under applicable law. This section will be enforced to
                            the extent permissible by applicable law. You may terminate the Agreements at any time by ending your use of the Noa Service.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            Sections 7, 9, 11, 14, 15, 16, 17, 19, 20, 21, 22, and 23 herein, as well as any other sections of the Agreements that, either explicitly or by their nature, must remain in
                            effect even after termination of the Agreements, shall survive termination.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 15. Warranty and disclaimer </h3>
                        <p>
                            {' '}
                            WE ENDEAVOUR TO PROVIDE THE BEST SERVICE WE CAN, BUT YOU UNDERSTAND AND AGREE THAT THE NOA SERVICE IS PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot;, WITHOUT EXPRESS OR IMPLIED
                            WARRANTY OR CONDITION OF ANY KIND. YOU USE THE NOA SERVICE AT YOUR OWN RISK. TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, NOA AND ALL OWNERS OF THE CONTENT MAKE NO
                            REPRESENTATIONS AND DISCLAIM ANY WARRANTIES OR CONDITIONS OF SATISFACTORY QUALITY, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. NEITHER NOA NOR
                            ANY OWNER OF CONTENT WARRANTS THAT THE NOA SERVICE IS FREE OF MALWARE OR OTHER HARMFUL COMPONENTS. IN ADDITION, NOA MAKES NO REPRESENTATION NOR DOES IT WARRANT, ENDORSE,
                            GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY THIRD PARTY APPLICATIONS (OR THE CONTENT THEREOF), USER CONTENT, OR ANY OTHER PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A
                            THIRD PARTY ON OR THROUGH THE NOA SERVICE OR ANY HYPERLINKED WEBSITE, OR FEATURED IN ANY DISPLAY OR OTHER ADVERTISING. YOU UNDERSTAND AND AGREE THAT NOA IS NOT RESPONSIBLE
                            OR LIABLE FOR ANY TRANSACTION BETWEEN YOU AND THIRD PARTY PROVIDERS OF THIRD PARTY APPLICATIONS OR PRODUCTS OR SERVICES ADVERTISED ON OR THROUGH THE NOA SERVICE. AS WITH
                            ANY PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE. NO ADVICE OR INFORMATION
                            WHETHER ORAL OR IN WRITING OBTAINED BY YOU FROM NOA SHALL CREATE ANY WARRANTY ON BEHALF OF NOA IN THIS REGARD. SOME ASPECTS OF THIS SECTION MAY NOT APPLY IN SOME
                            JURISDICTIONS IF PROHIBITED BY APPLICABLE LAW.
                            {' '}
                        </p>
                        <p> THIS DOES NOT AFFECT YOUR STATUTORY RIGHTS AS A CONSUMER. </p>
                        <h3 className={css(styles.sectionTitle)}> 16. Limitation </h3>
                        <p>
                            {' '}
                            YOU AGREE THAT, TO THE EXTENT PERMITTED BY APPLICABLE LAW, YOUR SOLE AND EXCLUSIVE REMEDY FOR ANY PROBLEMS OR DISSATISFACTION WITH THE NOA SERVICE IS TO UNINSTALL ANY NOA
                            SOFTWARE AND TO STOP USING THE NOA SERVICE. WHILE NOA ACCEPTS NO RESPONSIBILITY FOR THIRD PARTY APPLICATIONS OR THE CONTENT THEREOF, AND WHILE YOUR RELATIONSHIP WITH SUCH
                            THIRD PARTY APPLICATIONS MAY BE GOVERNED BY SEPARATE AGREEMENTS WITH SUCH THIRD PARTIES, TO THE EXTENT PERMITTED BY APPLICABLE LAW, YOUR SOLE AND EXCLUSIVE REMEDY, AS WITH
                            RESPECT TO NOA, FOR ANY PROBLEMS OR DISSATISFACTION WITH THIRD PARTY APPLICATIONS OR THE CONTENT THEREOF, IS TO UNINSTALL AND/OR STOP USING ANY SUCH THIRD PARTY
                            APPLICATIONS.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT WILL NOA, ITS OFFICERS, SHAREHOLDERS, EMPLOYEES, AGENTS, DIRECTORS, SUBSIDIARIES, AFFILIATES, SUCCESSORS, ADVISORS,
                            SUPPLIERS, OR LICENSORS BE LIABLE FOR (1) ANY INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, EXEMPLARY, OR CONSEQUENTIAL DAMAGES; (2) ANY LOSS OF USE, DATA, BUSINESS, OR PROFITS
                            (WHETHER DIRECT OR INDIRECT), IN ALL CASES ARISING OUT OF THE USE OR INABILITY TO USE THE NOA SERVICE, THIRD PARTY APPLICATIONS, OR THIRD PARTY APPLICATION CONTENT,
                            REGARDLESS OF LEGAL THEORY, WITHOUT REGARD TO WHETHER NOA HAS BEEN WARNED OF THE POSSIBILITY OF THOSE DAMAGES, AND EVEN IF A REMEDY FAILS OF ITS ESSENTIAL PURPOSE; OR (3)
                            AGGREGATE LIABILITY FOR ALL CLAIMS RELATING TO THE NOA SERVICE, THIRD PARTY APPLICATIONS, OR THIRD PARTY APPLICATION CONTENT MORE THAN THE AMOUNTS PAID BY YOU TO NOA DURING
                            THE PRIOR TWELVE MONTHS IN QUESTION, TO THE EXTENT PERMISSIBLE BY APPLICABLE LAW.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            Nothing in the Agreements removes or limits Noa’s liability for fraud, fraudulent misrepresentation, death or personal injury caused by its negligence, and, if required by
                            applicable law, gross negligence. Some aspects of this section may not apply in some jurisdictions if prohibited by applicable law.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 17. Third party rights </h3>
                        <p>
                            {' '}
                            You acknowledge and agree that the owners of the Content and certain distributors (such as app store providers) are intended beneficiaries of the Agreements and have the
                            right to enforce the Agreements directly against you. Other than as set out in this section, the Agreements are not intended to grant rights to anyone except you and Noa,
                            and in no event shall the Agreements create any third party beneficiary rights. Furthermore, the rights to terminate, rescind, or agree to any variation, waiver, or
                            settlement of the Agreements are not subject to the consent of any other person.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 18. Entire agreement </h3>
                        <p>
                            {' '}
                            Other than as stated in this section or as explicitly agreed upon in writing between you and Noa, the Agreements constitute all the terms and conditions agreed upon between
                            you and Noa, AND SUPERSEDE ANY PRIOR AGREEMENTS IN RELATION TO THE SUBJECT MATTER OF THESE AGREEMENTS, WHETHER WRITTEN OR ORAL.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            Please note, however, that other aspects of your use of the Noa Service may be governed by additional agreements. That could include, for example, access to the Noa Service
                            as a result of a gift card or Code or free or discounted Trials. When you are presented with an offer for such aspects of your use, you will be presented with any related
                            additional agreement, and you may have an opportunity to agree to additional terms. TO THE EXTENT THAT THERE IS ANY IRRECONCILABLE CONFLICT BETWEEN ANY ADDITIONAL TERMS AND
                            THESE TERMS, THE ADDITIONAL TERMS SHALL PREVAIL.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 19. Severability and waiver </h3>
                        <p>
                            {' '}
                            Unless as otherwise stated in the Agreements, should any provision of the Agreements be held invalid or unenforceable for any reason or to any extent, such invalidity or
                            enforceability shall not in any manner affect or render invalid or unenforceable the remaining provisions of the Agreements, and the application of that provision shall be
                            enforced to the extent permitted by law.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            ANY FAILURE BY Noa OR ANY THIRD PARTY BENEFICIARY TO ENFORCE THE AGREEMENTS OR ANY PROVISION THEREOF SHALL NOT PROVISION NOA’S OR THE APPLICABLE THIRD PARTY BENEFICIARY’S
                            RIGHT TO DO SO.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 20. Assignment </h3>
                        <p>
                            {' '}
                            Noa may assign the Agreements or any part of them, and Noa may delegate any of its obligations under the Agreements. You may not assign the Agreements or any part of them,
                            nor transfer or sub-license your rights under the Agreements, to any third party.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 21. Indemnification </h3>
                        <p>
                            {' '}
                            To the fullest extent permitted by applicable law, you agree to indemnify and hold Noa, including its officers, directors, employees, agents, successors and assigns,
                            harmless from and against all damages, losses, and expenses of any kind (including reasonable legal fees and costs) arising out of: (1) your breach of this Agreement; (2)
                            any User Content; (3) any activity in which you engage on or through the Noa Service; and (4) your violation of any law or the rights of a third party.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 22. Force Majeure </h3>
                        <p>
                            {' '}
                            Noa will not be liable or deemed to be in default for any delay or failure in performance or interruption of the delivery of the Noa Service that may result directly or
                            indirectly from any cause or circumstance beyond its or their reasonable control, including but not limited to failure of electronic or mechanical equipment or
                            communication lines, telephone or other interconnect problems, computer viruses, unauthorised access, theft, operator errors, severe weather, earthquakes or natural
                            disasters, strikes or other labour problems, wars, or governmental restrictions.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 23. Governing Law and Jurisdiction </h3>
                        <p>
                            {' '}
                            These Terms shall be governed by, and construed in accordance with, Irish law. The parties irrevocably agree that the courts of Ireland shall (subject to the paragraph
                            below) have exclusive jurisdiction to settle any dispute which may arise out of, under, or in connection with these Terms or the legal relationship established by them, and
                            for those purposes irrevocably submit all disputes to the jurisdiction of the Irish courts.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            For the exclusive benefit of Noa, Noa shall also retain the right to bring proceedings as to the substance of the matter in the courts of the country of your residence or,
                            where these Terms are entered into in the course of your trade or profession, the country of your principal place of business.
                            {' '}
                        </p>
                        <h4 className={css(styles.sectionSubTitle)}> 23.1 ARBITRATION </h4>
                        <p>
                            {' '}
                            If you are located in, are based in, have offices in, or do business in a jurisdiction in which this Section 23.2 is enforceable, the following mandatory arbitration
                            provisions apply to you:
                            {' '}
                        </p>
                        <h5 className={css(styles.sectionSmallSubTitle)}> 23.1.1 Dispute resolution and arbitration </h5>
                        <p>
                            {' '}
                            You and Noa agree that any dispute, claim, or controversy between you and Noa arising in connection with or relating in any way to these Agreements or to your relationship
                            with Noa as a user of the Service (whether based in contract, tort, statute, fraud, misrepresentation, or any other legal theory, and whether the claims arise during or
                            after the termination of the Agreements) will be determined by mandatory binding individual arbitration. Arbitration is more informal than a lawsuit in court. THERE IS NO
                            JUDGE OR JURY IN ARBITRATION, AND COURT REVIEW OF AN ARBITRATION AWARD IS LIMITED. There may be more limited discovery than in court. The arbitrator must follow this
                            agreement and can award the same damages and relief as a court (including legal fees), except that the arbitrator may not award declaratory or injunctive relief benefiting
                            anyone but the parties to the arbitration. This arbitration provision will survive termination of the Agreements.
                            {' '}
                        </p>
                        <h5 className={css(styles.sectionSmallSubTitle)}> 23.1.2 Arbitration rules </h5>
                        <p>
                            {' '}
                            Either you or we may start arbitration proceedings. If you are located in, are based in, have offices in, or do business in Ireland, any arbitration between you and Noa
                            will be finally settled under the Arbitration Act 2010
                            {' '}
                        </p>
                    </View>
                </Container>

                {!!this.props.showSitemap && <LandingPageNewSitemap />}
            </Page>
        );
    }
}

const styles = StyleSheet.create({
    page: {
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 15,
            paddingTop: 25,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 14,
        },
        backgroundColor: newtheme.darkmodeColors.backgroundNavy,
        color: newtheme.darkmodeColors.slightlyFadedText,
        fontSize: 17,
        paddingTop: 50,
        paddingBottom: 150,
    },
    title: {
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 30,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 25,
        },
        fontSize: 35,
        marginTop: 0,
        marginBottom: 25,
        color: newtheme.darkmodeColors.white,
    },
    sectionTitle: {
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 23,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 21,
        },
        fontSize: 25,
        marginTop: 50,
        color: newtheme.darkmodeColors.white,
    },
    sectionSubTitle: {
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 16,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 15,
        },
        fontSize: 18,
        marginTop: 35,
    },
    sectionSmallSubTitle: {
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 15,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 14,
        },
        fontSize: 17,
        marginTop: 30,
    },
    tableHeader: {
        [`@media (max-width: ${theme.breakpoints.medium}px)`]: {
            whiteSpace: 'normal',
            minWidth: 150,
        },
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            minWidth: 125,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            minWidth: 115,
            paddingRight: 5,
        },
        [`@media (max-width: ${theme.breakpoints.minuscule}px)`]: {
            minWidth: 110,
            paddingRight: 0,
        },
        whiteSpace: 'nowrap',
        paddingRight: 10,
        verticalAlign: 'top',
    },
});

export default Terms;
